import React, {Component} from 'react';
import MaterialIcon from '../MaterialIcon';
import {Line, Pie} from "react-chartjs-2";
import {ChartOptions} from "./ChartSetup";
import { Chart, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js';
import EditorMenu from "./EditorMenu";
import {connect} from "react-redux";
import DatePickerRange from "../DatePicker";
import Axios from "axios";
import getAxiosConfig from "../../utils/axiosConfig";
import {showToastForBackend, showToastForFrontend} from "../../actions/toastActions";
import {FormattedMessage} from 'react-intl';

class ChartCard extends Component {
    constructor(props) {
        super(props);
        this.chartResponse = {
            lineChartData: {
                labels: [],
                datasets: []
            },
            pieChartData: {}
        };
        this.state = {
            renderData: ''
        };
        this.updateTitle = this.updateTitle.bind(this);
        this.updateInput = this.updateInput.bind(this);
        this.updateChart = this.updateChart.bind(this);
        this.updatePeriod = this.updatePeriod.bind(this);
        Chart.register(CategoryScale);
        Chart.register(LinearScale);
        Chart.register(PointElement);
        Chart.register(LineElement);

    }

    componentDidMount() {
        Axios.get(this.props.properties.chartUrl + this.props.chart.id, getAxiosConfig())
            .then(chartResponse => {
                this.chartResponse = chartResponse.data;
                this.setState({renderData: new Date()});
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    componentDidUpdate(_prevProps) {
        if (_prevProps.chart !== this.props.chart) {
            this.updateChart(this.props.chart);
        }
    }

    updateChart(chart) {
        chart['userEmail'] = localStorage.getItem("user");
        Axios.put(this.props.properties.chartUrl + chart.id, chart, getAxiosConfig())
            .then(chartResponse => {
                if (chartResponse) {
                    this.chartResponse = chartResponse.data;
                    this.setState({renderData: new Date()});
                }
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    updateTitle(event, chart) {
        event.preventDefault();
        this.updateChart(chart);
    }

    updateInput(event) {
        this.props.changeProperty(this.props.chart.id, ["title"], [event.target.value]);
    }

    updatePeriod(event) {
        this.props.changeProperty(this.props.chart.id, ["period"], [event.target.value]);
    }

    render() {
        const displayChartAccordingToType = (chartType, active) => {
            if (typeof this.props.chart !== "undefined" && active) {
                if (chartType === "Graph") {
                    return <Line data={this.chartResponse.lineChartData} options={ChartOptions.LineChartOptions}/>;
                }
                if (chartType === "Pie Chart") {
                    return <Pie data={this.chartResponse.pieChartData} options={ChartOptions.PieChartOptions}/>;
                }
                if (chartType === "Value") {
                    return <div className="big-number">{this.chartResponse.value}</div>;
                }
            } else if (!active) {
                return <div className="big-number"><MaterialIcon icon="visibility_off"/></div>;
            }
        };
        return (
            <div className={(this.props.chart.chartWidth === "Large" && "col-md-8") ||
            (this.props.chart.chartWidth === "Normal" && "col-md-6") ||
            (this.props.chart.chartWidth === "Small" && "col-md-4")}>
                <div className="panel-wrapper">
                    <div className="graph-name-wrapper">
                        <form onSubmit={event => this.updateTitle(event, this.props.chart)}>
                            <input value={this.props.chart.title} readOnly={this.props.isReadOnly} onChange={event => this.updateInput(event)}/>
                            <button className="chart-save-button"
                                    onClick={event => this.updateTitle(event, this.props.chart)}
                                    disabled={!this.props.chart.title || this.props.isReadOnly}><FormattedMessage id="Save"/></button>
                        </form>
                    </div>
                    <div className="graph-container">
                        <div className="header">
                            <div className="row">
                                <div className="col-auto">
                                    <div
                                        className={"icon-button menu-button header-items " + (this.props.chart.chartSettings['editorMenuOpen'] ? "open" : "")+(this.props.isReadOnly ? "disabled" : "")}
                                        onClick={() => this.props.changeChartSetting(this.props.chart.id, ['editorMenuOpen'])}>
                                        <MaterialIcon icon="menu" size={24} readOnly ={this.props.isReadOnly}/>
                                    </div>
                                </div>
                                <div className="col">
                                    <DatePickerRange showGlobal={true}
                                                chart={this.props.chart}
                                                changeChartSetting={this.props.changeChartSetting}
                                                changeProperty={this.props.changeProperty} readOnly={this.props.isReadOnly}/>
                                    <div className="form-select header-items day-select">
                                        <span className="arrow"><MaterialIcon icon="keyboard_arrow_down"
                                                                              size={24} readOnly ={this.props.isReadOnly}/></span>
                                        <select className={this.props.isReadOnly ? " disabled" : "" } onChange={this.updatePeriod} defaultValue={this.props.chart.period}>
                                            <FormattedMessage id="Month">
                                                {(text) => <option value="MONTH">{text}</option>}
                                            </FormattedMessage>
                                            <FormattedMessage id="Week">
                                                {(text) => <option value="WEEK">{text}</option>}
                                            </FormattedMessage>
                                            <FormattedMessage id="Day">
                                                {(text) => <option value="DAY">{text}</option>}
                                            </FormattedMessage>
                                            <FormattedMessage id="Hour">
                                                {(text) => <option value="HOUR">{text}</option>}
                                            </FormattedMessage>
                                        </select>
                                    </div>
                                    <div className={"icon-button resize-dropdown header-items" + (this.props.isReadOnly ? " disabled" : "")} >
                                        <button className="resize-button" disabled={this.props.isReadOnly}>
                                            <MaterialIcon icon="dynamic_feed" size={24} readOnly ={this.props.isReadOnly}/>
                                        </button>
                                        <ul className="resize-options">
                                            <li onClick={() => this.props.changeProperty(this.props.chart.id, ["chartWidth"], ["Large"])}
                                                className={this.props.chart.chartWidth === "Large" ? "selected" : ""}>
                                                <FormattedMessage id="Large"/>
                                            </li>
                                            <li onClick={() => this.props.changeProperty(this.props.chart.id, ["chartWidth"], ["Normal"])}
                                                className={this.props.chart.chartWidth === "Normal" ? "selected" : ""}>
                                                <FormattedMessage id="Normal"/>
                                            </li>
                                            <li onClick={() => this.props.changeProperty(this.props.chart.id, ["chartWidth"], ["Small"])}
                                                className={this.props.chart.chartWidth === "Small" ? "selected" : ""}>
                                                <FormattedMessage id="Small"/>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="canvas-container">
                            {displayChartAccordingToType(this.props.chart.chartSettings['type'], this.props.chart.chartSettings['active'])}
                            <EditorMenu chart={this.props.chart}
                                        changeChartSetting={(chartId, properties) => this.props.changeChartSetting(chartId, properties)}
                                        changeProperty={(chartId, properties, values) => this.props.changeProperty(chartId, properties, values)}
                                        changeChartType={(chartId, property, value) => this.props.changeChartType(chartId, property, value)}
                                        updateChart={this.updateChart}
                                        deleteChart={(chartId) => this.props.deleteChart(chartId)}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        analyticsDatePicker: state.analyticsDatePicker
    }
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(ChartCard);